import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { PerspectiveProvider } from "@/context/PerspectiveContext";
import { BrochureGateProvider } from "@/context/BrochureGateContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Gemeenten from "@/pages/Gemeenten";
import Deelnemers from "@/pages/Deelnemers";
import Programma from "@/pages/Programma";
import Methode from "@/pages/Methode";
import OverOns from "@/pages/OverOns";
import Faq from "@/pages/Faq";
import Contact from "@/pages/Contact";
import Trainingen from "@/pages/Trainingen";
import TrainingDetail from "@/pages/TrainingDetail";
import Verhalen from "@/pages/Verhalen";
import Partners from "@/pages/Partners";
import EvcVigor from "@/pages/EvcVigor";
import Startkwalificaties from "@/pages/Startkwalificaties";
import Kennisbank from "@/pages/Kennisbank";
import KennisbankArtikel from "@/pages/KennisbankArtikel";
import Pilot from "@/pages/Pilot";
import Onderwijs from "@/pages/Onderwijs";
import VoorJou from "@/pages/VoorJou";
import VoorGemeenten from "@/pages/VoorGemeenten";
import Manifest from "@/pages/Manifest";
import Vonkvinder from "@/pages/Vonkvinder";
import Programmabouwer from "@/pages/Programmabouwer";
import Probeer from "@/pages/Probeer";
import Moodboards from "@/pages/Moodboards";
import MoodboardA from "@/pages/MoodboardA";
import MoodboardB from "@/pages/MoodboardB";
import MoodboardC from "@/pages/MoodboardC";
import VoorOpdrachtgevers from "@/pages/VoorOpdrachtgevers";
import OnderzoekEnPilot from "@/pages/OnderzoekEnPilot";
import EvcZelfscan from "@/pages/EvcZelfscan";
import Privacy from "@/pages/Privacy";
import Disclaimer from "@/pages/Disclaimer";
import Cookies from "@/pages/Cookies";
import Voorwaarden from "@/pages/Voorwaarden";
import NotFound from "@/pages/NotFound";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <PerspectiveProvider>
          <BrochureGateProvider>
          <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/gemeenten" element={<Gemeenten />} />
            <Route path="/deelnemers" element={<Deelnemers />} />
            <Route path="/programma" element={<Programma />} />
            <Route path="/methode" element={<Methode />} />
            <Route path="/trainingen" element={<Trainingen />} />
            <Route path="/trainingen/:key" element={<TrainingDetail />} />
            <Route path="/verhalen" element={<Verhalen />} />
            <Route path="/startkwalificaties" element={<Startkwalificaties />} />
            <Route path="/kennisbank" element={<Kennisbank />} />
            <Route path="/kennisbank/:slug" element={<KennisbankArtikel />} />
            <Route path="/pilot" element={<Pilot />} />
            <Route path="/onderwijs" element={<Onderwijs />} />
            <Route path="/voor-jou" element={<VoorJou />} />
            <Route path="/voor-gemeenten" element={<VoorGemeenten />} />
            <Route path="/manifest" element={<Manifest />} />
            <Route path="/vonkvinder" element={<Vonkvinder />} />
            <Route path="/programmabouwer" element={<Programmabouwer />} />
            <Route path="/probeer" element={<Probeer />} />
            <Route path="/moodboard" element={<Moodboards />} />
            <Route path="/moodboard/a" element={<MoodboardA />} />
            <Route path="/moodboard/b" element={<MoodboardB />} />
            <Route path="/moodboard/c" element={<MoodboardC />} />
            <Route path="/voor-opdrachtgevers" element={<VoorOpdrachtgevers />} />
            <Route path="/onderzoek-en-onderbouwing" element={<OnderzoekEnPilot />} />
            <Route path="/onderzoek-en-pilot" element={<Navigate to="/onderzoek-en-onderbouwing" replace />} />
            <Route path="/evc-zelfscan" element={<EvcZelfscan />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/partners/evc-vigor" element={<EvcVigor />} />
            <Route path="/over-ons" element={<OverOns />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/cookies" element={<Cookies />} />
            <Route path="/voorwaarden" element={<Voorwaarden />} />
            {/* legacy redirects */}
            <Route
              path="/trainingen/gemeenteambtenaren"
              element={<Navigate to="/trainingen/gemeentelijke-professionals" replace />}
            />
            <Route path="/verwijzers" element={<Navigate to="/gemeenten" replace />} />
            <Route path="/visie" element={<Navigate to="/over-ons" replace />} />
            {/* 404 */}
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
          </BrochureGateProvider>
        </PerspectiveProvider>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
